import { render, staticRenderFns } from "./fragment-gfx-board.vue?vue&type=template&id=89cbe8d0&scoped=true&"
import script from "./fragment-gfx-board.vue?vue&type=script&lang=js&"
export * from "./fragment-gfx-board.vue?vue&type=script&lang=js&"
import style0 from "./fragment-gfx-board.vue?vue&type=style&index=0&id=89cbe8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cbe8d0",
  null
  
)

export default component.exports